<script setup>
import { ref, toRefs } from "vue";

const props = defineProps({
  series: Array,
  height: Number,
  colors: Array,
  title: String,
  categories: Array,
});

const { series, height, colors, title, categories } = toRefs(props);

const chartOptions = ref({
  chart: {
    height: height,
    type: "area",
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  colors: colors,
  title: {
    text: title,
    align: "left",
    style: {
      fontSize: "20px",
      fontWeight: "bold",
      color: "#263238",
    },
  },
  grid: {
    row: {
      colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    categories: categories,
  },
});
</script>

<template>
  <apexchart
    :type="chartOptions.chart.type"
    :height="chartOptions.chart.height"
    :options="chartOptions"
    :series="series"
  />
</template>
